
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"m1.571 7.827 6.112-6.111a2.665 2.665 0 0 1 4.55 1.884v.673m0 0h.673a2.665 2.665 0 0 1 1.884 4.55l-4.778 4.78a1.885 1.885 0 0 0 0 2.665m2.22-11.995L6.68 9.826m2.887-6.441L4.681 8.272a1.885 1.885 0 0 0 0 2.665l.888.888c.736.736 1.93.736 2.666 0L13.12 6.94"}})])
          )
        }
      }
    